import BaseService from './BaseService';

export default class SalesmanMonthlyCommissionService extends BaseService {
    static getAll(query: string, params?: any) {
        return this.get('reports/bi/stats', query, params).then((res) => res.data.data);
        // Is this will log error?
    }
}
